module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-291.12e30a2.woff2";